import { useEventListener } from '@vueuse/core';
import { getCookieValue, setCookie } from '@/js/helpers/cookieHelpers';

function getQuerySelector(element: Element | null): string | null {
    if (!element) {
        return null;
    }

    const parts: string[] = [];
    let current: Element | null = element;

    while (current && current.nodeType === Node.ELEMENT_NODE) {
        let selector = current.nodeName.toLowerCase();

        if (current.id) {
            selector += `#${CSS.escape(current.id)}`;
            parts.unshift(selector);
            break;
        }

        const classList = Array.from(current.classList).map((cls) => `.${CSS.escape(cls)}`);
        if (classList.length) {
            selector += classList.join('');
        }

        const parent = current.parentElement;
        if (parent) {
            const siblings = Array.from(parent.children);
            const index = siblings.indexOf(current) + 1;
            selector += `:nth-child(${index})`;
        }

        parts.unshift(selector);
        current = current.parentElement;
    }

    return parts.join(' > ');
}

const getTrackingData = (cookieName: string) => {
    const cookieValue = getCookieValue(cookieName);
    if (!cookieValue) {
        return {};
    }

    try {
        return JSON.parse(cookieValue);
    } catch (e) {
        return {};
    }
};

const updateVulprCookie = (additionalData = null): void => {
    const cookieName = 'vulpr';
    const cookieExpiration = 730;

    const trackingData = getTrackingData(cookieName);
    if (!trackingData.client_id) {
        trackingData.client_id = crypto.randomUUID();
    }

    trackingData.latest_visited_page = window.location.href;

    if (additionalData) {
        Object.assign(trackingData, additionalData);
    }

    setCookie(cookieName, JSON.stringify(trackingData), cookieExpiration);
};

const handleGoonLinkClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const link = target.closest('a[href*="/goon/"]') as HTMLAnchorElement;

    if (!link) {
        return;
    }

    const category = link.dataset.category;
    const position = link.dataset.position;

    let tag = category;
    if (category && position) {
        tag += `-${position}`;
    }

    updateVulprCookie({
        tags: [tag || getQuerySelector(link)],
    });
};

useEventListener(document, 'DOMContentLoaded', () => {
    updateVulprCookie();
});

useEventListener(document, 'click', handleGoonLinkClick);
